import { Component, Inject, OnInit } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  standalone: false
})
export class LogoutComponent {

  constructor(@Inject(OKTA_AUTH) private readonly oktaAuth: OktaAuth) { }

  login() {
    this.oktaAuth.signInWithRedirect({
      originalUri: '/home'
    });
  }  
}
